<template>
    <v-container class="gradient-bg" fluid style="height:100%;">
        <v-row align="center" justify="space-around" style="height:100%">
            <v-col align="center" cols="12" md="6">
                <v-card max-width="500" max-height="500">
                    <v-card-title class="headline">Enter Code from Authenticator</v-card-title>
                    <v-card-text>
                        <v-text-field label="Code" v-model="code" outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="gradient-button" @click="confirmTotp">Confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { supabase } from '../supabase'  
export default {
    data() {
        return {
            code: '',
            challengeId: null,
            factorId: null
        }
    },
    methods: {
        async confirmTotp() {
            
            const { data, error } = await supabase.auth.mfa.verify({
                factorId: this.factorId,
                challengeId: this.challengeId,
                code: this.code
            })
            if (error) {
                alert('Error confirming TOTP: ' + error.message)
                console.error('Error confirming TOTP:', error)
                return
            }
            console.log(data);
            
            this.$store.commit('SET_VERIFY_TOTP', false)
            this.$router.push('/dashboard')
        },
    },
    async mounted() {
        console.log('Mounted VeryfyTotp');
        
        const { data: { user } } = await supabase.auth.getUser()
        console.log('user', user);
        
        const factors = user.factors || []
        // Prioritize a verified factor, otherwise take the first one (setup scenario)
        let factor = factors.find(f => f.status === 'verified')
        if (!factor) {
            factor = factors[0]
        }

        if (!factor) {
            console.error('No factors found for user')
            alert('No authentication factors found. Please contact support.')
            return
        }

        const { data, error } = await supabase.auth.mfa.challenge({
            factorId: factor.id
        })
        console.log('Challenge created:', data, error);
        
        if (error) {
            console.error('Challenge error:', error)
            return
        }

        this.factorId = factor.id
        this.challengeId = data.id
    }
}
</script>